<template>
	<div style="width: 100%;height: 100%;background: #eceef1;">
		<Layout-Top menuName="账号绑定" prevUrl="/WeChat/Person">
		</Layout-Top>
		<!-- <Row type="flex" justify="center" align="center" style="height: 46px;width: 100%; background: #eceef1;line-height: 46px;">
			<Col span="2">
				<Icon style="margin-top: -2px;" size="28" type="ios-arrow-back" />
			</Col>
			<Col span="22">
				账号绑定 
			</Col>
		</Row> -->
		
		<div style="height: 56px;width: 100%;">
			<Row type="flex" justify="center" align="center" :style="{height: '56px',width: '100%',background: '#f8f8f9','line-height': '56px'}">
				<Col span="6" style="padding-left: 16px;">
					ID号
				</Col>
				<Col span="16" style="text-align: right;">
					gdff1wq522
				</Col>
				<Col span="2">
				</Col>
			</Row>
		</div>
		
		<Row type="flex" justify="center" align="center" style="height: 0px;">
			<Col span="3">
				
			</Col>
			<Col span="21">
				<Divider style="margin-top: 0px;" />
			</Col>
		</Row>
		<div @click="toPage('/WeChat/Person/Account/Phone')" style="width: 100%;">
			<Row type="flex" justify="center" align="center" style="height: 56px;width: 100%; background: #f8f8f9;line-height: 56px;">
				<Col span="6" style="padding-left: 16px;">
					手机号
				</Col>
				<Col span="16" style="text-align: right;">
					<Icon v-if="person.pphone!=''" color="#19be6b" style="margin-top: -3px;" type="ios-lock" />{{person.pphone!=''?person.pphone:'未绑定'}}
				</Col>
				<Col span="2">
					<Icon style="margin-top: -2px;" size="28" type="ios-arrow-forward" />
				</Col>
			</Row>
		</div>
		<div @click="toPage('/WeChat/Person/Account/IdCard')" style="width: 100%;">
			<Row type="flex" justify="center" align="center" style="height: 56px;width: 100%; background: #f8f8f9;line-height: 56px;margin-top: 6px;">
				<Col span="6" style="padding-left: 16px;">
					身份证
				</Col>
				<Col span="16" style="text-align: right;">
					<Icon v-if="person.pno!=''" color="#2db7f5" style="margin-top: -3px;" type="ios-card" />{{person.pno!=''?person.psno:'未绑定'}}
				</Col>
				<Col span="2">
					<Icon style="margin-top: -2px;" size="28" type="ios-arrow-forward" />
				</Col>
			</Row>
		</div>
		<div @click="mailPending?toPage('/WeChat/Person/Account/Mail'):mailShow=true" style="width: 100%;">
			<Row type="flex" justify="center" align="center" style="height: 56px;width: 100%; background: #f8f8f9;line-height: 56px;margin-top: 6px;">
				<Col span="6" style="padding-left: 16px;">
					电子邮箱
				</Col>
				<Col span="16" style="text-align: right;">
					<Icon v-if="person.pmail!=''" color="#2d8cf0" style="margin-top: -3px;" type="ios-mail" />{{person.pmail!==''?person.pmail:'未绑定'}}
				</Col>
				<Col span="2">
					<Icon style="margin-top: -2px;" size="28" type="ios-arrow-forward" />
				</Col>
			</Row>
		</div>
		<Modal
			v-model="mailShow"
			:mask-closable="false"
			:footer-hide="true"
			:styles="{padding:'8px'}"
			>
			
			<div slot="header" style="text-align: center;font-size: 18px;">
				修改邮箱地址
			</div>
			<div slot="close"></div>
			<div style="height: 80px;padding-top: 43px;padding-bottom:6px ;">
				<Row type="flex" justify="center" align="center">
					<Col span="2">
					</Col>
					<Col span="20" style="font-size: 18px;">
						<input v-model="person.pmail" style="width: 100%;border-bottom:1px solid #eceef1 ;border-top: none;border-left: none;border-right: none;outline: none;" type="text" />
					</Col>
					<Col span="2">
					</Col>
				</Row>
			</div>
			<Row type="flex" justify="center" align="center" style="height: 66px;color:#ccc ;">
				
				<Col span="2">
				</Col>
				<Col span="20">
					如果你更改了邮箱地址，你需要对邮箱地址进行验证
				</Col>
				<Col span="2">
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center">
				<Col span="12" style="text-align: center;font-size: 18px;border-top: 1px solid #eceef1;border-right: 1px solid #eceef1;">
					<Button @click="mailShow=false,person.pmail=''" style="font-size: 16px;outline: none;box-shadow:none;" type="text" long>取消</Button>
				</Col>
				<Col span="12" style="text-align: center;font-size: 18px;border-top: 1px solid #eceef1;">
					<Button style="font-weight: 600;font-size: 16px;outline: none;box-shadow:none;" type="text" long>确定</Button>
				</Col>
			</Row>
		</Modal>
	</div>
</template>
<script>
	import Top from '../assembly'
	export default {
		components: {
			'Layout-Top': Top
		},
		data(){
			return {
				mailPending:false,
				person:{
					pmail:'',
					pphone:'15508313366',
					pno:'511526',
					psno:'5115****1022'
				},
				mailShow:false
			}
		},
		methods:{
			toPage(page){
				this.$router.push(page);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Account/index.vue